/**
 * Limits that both runtimes have to agree on.
 *
 * Same rule as domains.ts: imported by the browser bundle AND by the Pages
 * Function, so no imports and no runtime globals live here. The Function is the
 * only thing that enforces these numbers. They exist in one place so the UI can
 * never promise a window the server does not actually keep, which is how a
 * second page gets sent while the first alert is still open.
 */

/**
 * Global cooldown window. One press pages on-call, and every press inside this
 * many seconds answers 429 with the open alert instead of creating a second one.
 *
 * The Function returns the exact seconds remaining on a 429, so the SPA only
 * falls back to this value when a 429 arrives from something that is not our
 * Function, an edge rate limiter for instance.
 */
export const COOLDOWN_SECONDS = 300;

/**
 * Hard cap on the optional note. The input enforces it so the character counter
 * tells the truth, the Function enforces it again because the input is not a
 * security boundary.
 */
export const MAX_NOTE_CHARS = 200;

/**
 * The two request budgets, side by side, because the only thing that matters
 * about them is the relationship: PANIC_TIMEOUT_MS must stay strictly greater
 * than OPSGENIE_TIMEOUT_MS, with room for the work the Function does around the
 * upstream call (a cold Google JWKS fetch costs up to 5 seconds, plus the KV
 * read).
 *
 * Equal budgets produce the worst outcome this app has: the browser gives up at
 * the same moment the Function succeeds, so on-call is paged and the sender is
 * told "it is not clear whether the alert was created". They were kept in two
 * files once and were both 15000. Now they sit here, one line apart, and a
 * regression test asserts the gap.
 */
export const OPSGENIE_TIMEOUT_MS = 10_000;
export const PANIC_TIMEOUT_MS = 20_000;
